<template>
    <div class="subscription-condition-management">
        <div class="row">
            <div class="col-12">
                <h3 class="mb-4">{{ $t('cdb.subscriptions.payment_data') }}</h3>
            </div>
            <div class="mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.payment_method')" :full-width="true">
                    <template v-slot:action>
                        <span class="text-link" @click="openChangePaymentMethodModal">{{ $t('cdb.subscriptions.change') }}</span>
                    </template>
                    <template v-slot:value>
                        <component
                            v-if="selectedPaymentMethod !== null"
                            v-bind:is="getPaymentComponent"
                            :selectedPaymentMethod="selectedPaymentMethod"
                        ></component>
                    </template>
                </data-entry-column>
            </div>

            <div class="mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.invoice_address')" :full-width="true">
                    <template v-slot:action>
                        <span class="text-link" @click="openChangePaymentAddressModal">{{ $t('cdb.subscriptions.change') }}</span>
                    </template>
                    <template v-slot:value>
                        <component
                            v-bind:is="getAddressComponent"
                            :address="invoiceAddress"
                        ></component>
                    </template>
                </data-entry-column>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import StripeCardInfo from '../atoms/StripeCardInfo.vue';
import StripeSepaInfo from '../atoms/StripeSepaInfo.vue';
import AddressBox from "./AddressBox.vue";

export default {
    name: 'SubscriptionPaymentManagement',

    components: {
        AddressBox,
        DataEntryColumn,
        StripeCardInfo, StripeSepaInfo
    },

    props: {
        subscriptionData: null
    },

    data() {
        return {
            selectedPaymentMethod: null,
            paymentMethods: null,
            invoiceAddress: this.subscriptionData.invoice_address_data
        }
    },

    methods: {
        openChangePaymentMethodModal() {
            EventBus.$emit('init-change-payment-method', {
                subscriptionData: this.subscriptionData,
                paymentMethods: this.paymentMethods,
                selectedPaymentMethod: this.selectedPaymentMethod
            });
        },
        openChangePaymentAddressModal() {
            EventBus.$emit('init-change-address', { address: this.subscriptionData.invoice_address_data, title: 'change_invoice_address' });
        },
        loadAvailablePaymentMethods() {
            this.$axios.get('api/v1/payment_methods/available_payment_methods/', { params: { subscription: this.subscriptionData.uuid } })
                .then(response => {
                    this.paymentMethods = response.data.availablePaymentMethods
                    this.selectedPaymentMethod =  this.paymentMethods.find( pm => pm.id === this.subscriptionData.stripe_source );
                })
                .catch(error => {
                    this.selectedPaymentMethod = []
                });
        },
    },

    computed: {
        getPaymentComponent(){
            switch(this.selectedPaymentMethod.type) {
                case "card":
                    return "stripe-card-info"
                case "sepa":
                    return "stripe-sepa-info"
                default:
                    return ""
            }
        },
        getAddressComponent(){
            return "address-box";
        }
    },

    mounted() {
        this.loadAvailablePaymentMethods()
    }
}
</script>
